import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { AddressSchema, ClientSchema, ContactSchema } from "../generated/prisma/zod";

const c = initContract();

export const clientsContract = c.router({
  update: {
    method: "PATCH",
    path: "/clients/:id",
    responses: {
      200: ClientSchema.merge(
        z.object({
          addresses: AddressSchema.array(),
          contacts: ContactSchema.array(),
        }),
      ),
    },
    body: z.object({
      name: z.string().optional(),
      siret: z.string().optional().nullable(),
      erpCode: z.string().optional().nullable(),
      comment: z.string().optional().nullable(),
      emailDomain: z.string().optional().nullable(),
      address: z
        .object({
          id: z.string().optional(),
          street: z.string().optional(),
          zipCode: z.string().optional(),
          city: z.string().optional(),
          country: z.string().optional(),
        })
        .optional(),
    }),
    summary: "Update a client",
  },
  findAll: {
    method: "GET",
    path: "/clients",
    responses: {
      200: ClientSchema.merge(
        z.object({
          addresses: AddressSchema.array(),
          contacts: ContactSchema.array(),
        }),
      ).array(),
    },
    summary: "Find all clients",
  },
  findOne: {
    method: "GET",
    path: "/clients/:id",
    responses: {
      200: ClientSchema.merge(
        z.object({
          addresses: AddressSchema.array(),
          contacts: ContactSchema.merge(z.object({ clientId: z.string() })).array(),
        }),
      ),
    },
    summary: "Find one client",
  },
  create: {
    method: "POST",
    path: "/clients",
    responses: {
      201: ClientSchema.extend({
        addresses: AddressSchema.array(),
      }),
    },
    body: z.object({
      name: z.string(),
      address: z
        .object({
          street: z.string().optional(),
          zipCode: z.string().optional(),
          city: z.string().optional(),
        })
        .optional(),
      siret: z.string().optional().nullable(),
      erpCode: z.string().optional().nullable(),
      comment: z.string().optional().nullable(),
      emailDomain: z.string().optional().nullable(),
    }),
    summary: "Create a client",
  },
  remove: {
    method: "DELETE",
    path: "/clients/:id",
    body: z.object({}).optional(),
    responses: {
      200: ClientSchema,
      400: z.object({ message: z.string() }),
    },
    summary: "Delete a client",
  },
  upload: {
    method: "POST",
    path: "/clients/upload",
    contentType: "multipart/form-data",
    responses: {
      200: z.object({
        success: z.boolean(),
      }),
    },
    body: c.type<{ file: File }>(),
    summary: "Upload a clients CSV file for a company",
  },
});
